export default "__VITE_ASSET__CkeKarR2__"